<button type="button" class="btn btn-sm" [ngClass]="getGoModeClasses()">
  <i class="fa fa-check" aria-hidden="true"></i>
  Go Mode!
</button>
